import createCrudService from "@src/core/api/create-crud-service";
import { QUERY_KEYS } from "@src/shared/constants/query-keys";
import { TUniversityStatus } from "../types";
import { TBaseQuery } from "@src/shared/types/base-query";

export type TUniversityStatusQuery = TBaseQuery;

export type TUniversityStatusPayload = {
    name: string;
    description?: string;
    color?: string;
}

const universityStatusesApi = createCrudService<TUniversityStatus, TUniversityStatusQuery, TUniversityStatusPayload>({
    queryKey: [QUERY_KEYS.getUniversityStatuses],
    url: 'university-statuses',
  });

  export default universityStatusesApi;